"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APSelect = _interopRequireDefault(require("../../common/APSelect/APSelect"));
var _APDatePicker = _interopRequireDefault(require("../../common/APDatePicker/APDatePicker"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var InterestPaymentsHeaderFormComponent = function InterestPaymentsHeaderFormComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('interest'),
    t = _useTranslation.t;
  var getInterestBalances = props.getInterestBalances,
    resetActivePage = props.resetActivePage,
    setEndDate = props.setEndDate,
    clearFilters = props.clearFilters,
    endDate = props.endDate,
    products = props.products;
  return /*#__PURE__*/_react["default"].createElement("form", {
    className: baseClasses('select-buttons', 'interest-payments')
  }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "product",
    customClass: baseClasses(),
    label: "".concat(t('Product'), ":"),
    options: [{
      value: 'all',
      label: t('All')
    }].concat(products.map(function (i) {
      return {
        value: i.ProductId,
        label: t(i.ProductFullName)
      };
    })),
    onSelect: resetActivePage,
    showTriangles: true
  }), /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    name: "startDate",
    customClass: baseClasses('from'),
    customChange: function customChange(value) {
      resetActivePage();
      if (value && !endDate) {
        setEndDate(new Date());
      }
    },
    label: t('Date range:'),
    format: function format(value) {
      return value;
    },
    maxDate: new Date()
  }), /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    name: "endDate",
    customClass: baseClasses('to'),
    label: t('to'),
    format: function format(value) {
      return value;
    },
    customChange: resetActivePage,
    maxDate: new Date()
  }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: baseClasses(),
    classModifiers: "clear-filters",
    type: "button",
    onClick: clearFilters
  }, t('Clear Filters')), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: baseClasses(),
    classModifiers: "clear-filters",
    type: "button",
    onClick: getInterestBalances
  }, t('Refresh')));
};
var _default = exports["default"] = InterestPaymentsHeaderFormComponent;